import { Dialog } from '../Dialog'
import { youtubeEmbedUrl } from './youtube'

const IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'

interface VideoPlayerDialogBaseProps {
  /** Заголовок плеера для скринридеров. */
  title: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Что играть: ролик YouTube по ID или файл с постером. */
export type VideoPlayerDialogProps = VideoPlayerDialogBaseProps &
  (
    | { videoId: string; fileUrl?: never; posterUrl?: never }
    | { fileUrl: string; posterUrl?: string; videoId?: never }
  )

/**
 * Окно с плеером: YouTube (`videoId`) или файл (`fileUrl`). Плеер монтируется, только пока окно открыто:
 * закрытие размонтирует его и останавливает видео.
 */
export function VideoPlayerDialog({
  videoId,
  fileUrl,
  posterUrl,
  title,
  open,
  onOpenChange,
}: VideoPlayerDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      className="max-w-[900px] overflow-hidden p-0"
      closeClassName="bg-black/50 text-white hover:bg-black/70 hover:text-white"
    >
      {open && (
        <div className="aspect-video w-full">
          {fileUrl ? (
            <video
              src={fileUrl}
              poster={posterUrl}
              title={title}
              controls
              autoPlay
              playsInline
              preload="metadata"
              className="h-full w-full bg-black"
            />
          ) : (
            <iframe
              src={videoId ? youtubeEmbedUrl(videoId) : undefined}
              title={title}
              allow={IFRAME_ALLOW}
              allowFullScreen
              className="h-full w-full"
            />
          )}
        </div>
      )}
    </Dialog>
  )
}
